export const TRANSLATIONS_IT = {
  email: "E-Mail",
  password: "Password",
  forgotpassword: "Hai dimenticato la password?",
  email_field_is_required: "Il campo e-mail è obbligatorio",
  reset_password: "Reimposta password",
  password_field_is_required: "Il campo password è obbligatorio",
  password_do_not_match: "La password non corrisponde",
  invalid_email_address: "Indirizzo e-mail non valido",
  leave_empty_to_keep_current: "Lascia vuoto per mantenere la password corrente",
  enter_email_address: "Inserire indirizzo e-mail",
  create_account: "Crea un account",
  dont_have_an_account: "Non hai un account?",
  already_have_an_account: "Hai già un account?",
  back_to_login: "Torna al login",
  activate_account: "Attiva account",
  activating_account: "Attivazione dell'account in corso...",
  activation_success: "Account attivato con successo!",
  activation_success_message: "Il tuo account è stato attivato con successo. Ora puoi accedere.",
  activation_failed: "Attivazione fallita",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Inserisci l'indirizzo e-mail associato al tuo account e ti invieremo un link per reimpostare la tua password.",
  dashboard: {
    title: "Dashboard",
    view_trees: "Visualizza alberi",
    view_sensors: "Visualizza sensori",
    greeting: "Ciao",
    data_status: "Stato dati",
    all_locations: "Tutte le località",
    last_30_days: "Ultimi 30 giorni",
    top_species: "Top 5 specie di alberi",
    top_species_info_title: "Top 5 specie di alberi",
    top_species_info_body:
      "Mostra le specie di alberi piu frequenti nei filtri correnti. I valori si basano sul numero di alberi per specie.",
    tasks_by_due_period: "Attività per periodo di scadenza",
    view_tasks: "Apri attività",
    health_last_30_days: "Salute ultimi 30 giorni",
    tree_health: "Salute degli alberi",
    health_overview: "Panoramica",
    group_inventory: "Inventario alberi",
    group_biometrics: "Biometria alberi",
    group_sensors: "Sensoristica e stato",
    group_recommendations: "Raccomandazioni",
    kpi_total_trees: "Numero di alberi",
    kpi_total_species: "Numero di specie di alberi",
    kpi_total_sensors: "Numero di sensori",
    kpi_sensor_types: "Tipi di sensori",
    kpi_maintenance_sensors: "Valori del sensore non plausibili",
    kpi_avg_height: "Altezza media",
    kpi_avg_trunk_circumference: "Circonferenza media del tronco",
    kpi_avg_crown_diameter: "Diametro medio della chioma",
    kpi_avg_age: "Età media",
    kpi_critical_sensors: "Sensori critici",
    kpi_disconnected_sensors: "Sensori disconnessi (ultime 3 ore)",
    kpi_recommended_actions: "Alberi con azione consigliata",
    sensor_types: "Tipi di sensori",
    avg_height: "Altezza media dell'albero",
    avg_trunk_diameter: "Diametro medio del tronco",
    avg_crown_diameter: "Diametro medio della chioma",
    avg_age: "Età media dell'albero",
    years_short: "anni",
    last_3_hours: "ultime 3 ore",
    no_data: "Nessun dato disponibile",
    no_health_data: "Nessun dato di salute disponibile",
    overview: "Panoramica",
  },
  dashboards: "Dashboards",
  esg: {
    title: "Monitoraggio ESG",
    subtitle: "Efficienza delle risorse",
    reporting_scope: "Ambito del report",
    generate_pdf: "Genera PDF",
    export_csv: "Esporta CSV",
    data_quality: "Qualità dei dati",
    completed_irrigation_volume: "Volume di irrigazione completato",
    estimated_water_saved: "Risparmio idrico stimato",
    irrigation_efficiency: "Efficienza di irrigazione",
    estimated_co2_avoided: "CO2 evitata stimata",
    liters: "litri",
    measured: "Misurato",
    estimated: "Stimato",
    derived: "Derivato",
    vs_last_period: "vs periodo precedente",
    irrigation_analysis: "Analisi dell'irrigazione",
    monthly_comparison: "Confronto mensile: Baseline stimata vs. irrigazione completata",
    monthly_comparison_through_current_month: "Confronto mensile fino al mese corrente incluso",
    baseline: "Baseline",
    completed: "Completato",
    water_saved: "Risparmio idrico",
    methodology: "Metodologia",
    calculation_basis: "Base di calcolo",
    data_coverage: "Copertura dati",
    included_assumptions: "Ipotesi incluse",
    exclusions: "Esclusioni e dati mancanti",
    all_projects: "Tutti i progetti",
    all_areas: "Tutte le aree",
    disclaimer_title: "Disclaimer",
    retry: "Riprova",
    // Metodologia – Base di calcolo
    calc_volume_source:
      "Il volume di irrigazione completato viene ricavato dalle attività di irrigazione completate e documentate.",
    calc_baseline_profile:
      "L'irrigazione baseline utilizza profili di cura predefiniti TreeSense basati sull'età dell'albero (anno di impianto).",
    calc_seasonal_weighting:
      "La baseline mensile è distribuita con un profilo di ponderazione stagionale concentrato nella stagione irrigua apr–set.",
    calc_water_saved:
      "Risparmio idrico = baseline meno volume di irrigazione completato, limitato a ≥ 0.",
    calc_co2_explanation:
      "La CO₂e evitata stimata viene calcolata in due passaggi. Innanzitutto, il risparmio idrico stimato viene convertito in domanda elettrica evitata utilizzando l'intensità energetica assunta del sistema idrico. Il risparmio elettrico risultante viene quindi moltiplicato per il fattore di emissione elettrica.",
    calc_co2_formula:
      "CO₂e evitata stimata = Risparmio idrico (m³) × Intensità energetica del sistema idrico (kWh/m³) × Fattore di emissione elettrica (kg CO₂e/kWh)",
    // Metodologia – Ipotesi incluse
    assumption_young_0_1: "Albero giovane anno 0–1: 3.000 l/anno (20 irrigazioni × 150 l)",
    assumption_young_2_3: "Albero giovane anni 2–3: 1.800 l/anno (12 irrigazioni × 150 l)",
    assumption_years_4_7: "Anni 4–7: 750 l/anno (5 irrigazioni × 150 l)",
    assumption_established:
      "Alberi consolidati (>7 anni): nessuna baseline modellata in questa prima bozza metodologica (non equivale a fabbisogno irriguo zero).",
    assumption_energy_intensity:
      "Intensità energetica del sistema idrico: 0,5 kWh/m³ (ipotesi interna di prima bozza; non ancora validata con dati locali dei fornitori).",
    assumption_emission_factor:
      "Fattore di emissione elettrica: 0,4 kg CO₂e/kWh (ipotesi interna di prima bozza; destinato a essere sostituito da un fattore specifico per anno di rendicontazione e area geografica).",
    assumption_seasonal:
      "Ponderazione stagionale: la baseline è fortemente concentrata in apr–set (~76%), con una piccola ponderazione residua al di fuori della stagione di punta.",
    // Metodologia – Esclusioni
    exclusion_missing_planting_year:
      "{{count}} record di alberi esclusi dalla baseline per anno di impianto mancante.",
    exclusion_large_transplant:
      "La baseline per grandi trapianti non è ancora modellata separatamente (nessun campo di identificazione affidabile).",
    exclusion_no_volume: "Le attività senza volume estraibile vengono ignorate.",
    // Metodologia – Disclaimer
    disclaimer_text:
      "Il volume di irrigazione completato si basa sulle voci di irrigazione documentate in litri registrate nella piattaforma TreeSense. Il risparmio idrico e la CO₂ evitata sono valori stimati calcolati utilizzando metodologie e ipotesi standardizzate.",
    // Qualità dei dati
    quality_good: "Buona",
    quality_partial: "Parziale",
    quality_insufficient: "Insufficiente",
    methodology_details: "Dettagli della metodologia",
    methodology_version: "Versione",
    methodology_updated: "Aggiornato",
    methodology_first_draft: "Aggiornato: prima bozza",
    // Metodologia – Riferimenti
    references: "Riferimenti",
    references_explanation:
      "Il GHG Protocol è utilizzato come base metodologica per la conversione dei dati di attività e del consumo elettrico in emissioni di gas serra. La conversione acqua-energia di TreeSense e i fattori numerici attualmente utilizzati sono ipotesi interne di prima bozza.",
    ref_corporate_standard: "GHG Protocol Corporate Standard",
    ref_scope2_guidance: "GHG Protocol Scope 2 Guidance",
    without_project_not_supported:
      "Il monitoraggio ESG non è ancora disponibile per gli alberi senza progetto. Seleziona un progetto o Tutti i progetti per visualizzare la dashboard.",
    year: "Anno",
    area: "Area",
  },
  newproject: "Nuovo progetto",
  logout: "Disconnettersi",
  viewproject: "Visualizza progetto",
  user: "Utente",
  users: "Utenti",
  persona: "Persona",
  username: "Nome utente",
  child_trees: "Alberi rappresentativi",
  save: "Salva",
  addTree: "Aggiungi albero",
  name: "Nome",
  image: "Immagine",
  update: "Aggiorna",
  login: "Accedi",
  signup: "Registrati",
  delete: "Elimina",
  saving: "Salvando ...",
  edit: "Modifica",
  project: {
    name: "Nome progetto",
    aim: "Tipo di progetto",
    select_aim: "Seleziona il tipo di progetto",
    description: "Descrizione del progetto",
    description_placeholder: "Descrivi brevemente il progetto",
    research_question: "Domanda di ricerca",
    research_question_placeholder: "Qual è la domanda di ricerca principale?",
    hypotheses: "Ipotesi da testare",
    hypotheses_placeholder: "Quali ipotesi devono essere testate?",
    methodology: "Metodologia",
    methodology_placeholder:
      "Descrivi metodologia, posizioni, selezione alberi e installazione sensori...",
    results: "Risultati",
    results_placeholder: "Quali sono i principali risultati del progetto?",
    limitations: "Limitazioni dei risultati / Significatività",
    limitations_placeholder: "Quanto sono significativi i risultati? Quali sono le limitazioni?",
    open_questions: "Domande aperte / Prossimi passi",
    open_questions_placeholder: "Quali domande rimangono aperte? Quali sono i prossimi passi?",
    challenges: "Problemi durante il progetto",
    challenges_placeholder: "Quali problemi si sono verificati? Di cosa aveva bisogno il cliente?",
    materials: "File/Foto/Materiali dal progetto",
    materials_placeholder: "Link a file, foto o altri materiali",
    aim_old_tree_monitoring: "Monitoraggio alberi vecchi",
    aim_irrigation_optimization_young_trees: "Ottimizzazione irrigazione: Alberi giovani",
    aim_technology_validation: "Validazione tecnologia",
    aim_smart_city: "Smart City",
    aim_partnership_project: "Progetto di partnership",
    aim_irrigation_optimization: "Ottimizzazione irrigazione",
    aim_mistletoe_control: "Controllo vischio",
    aim_groundwater_lowering_monitoring: "Monitoraggio abbassamento falda",
    aim_general_drought_stress_monitoring: "Monitoraggio generale stress da siccità",
    aim_irrigation_demand_determination: "Determinazione fabbisogno irriguo",
  },
  projects: "Progetti",
  add: "Aggiungi",
  trees: "Alberi",
  tree: "Albero",
  choose_tree: "Scegli un albero",
  customers: "Clienti",
  customer: "Cliente",
  tasks: "Compiti",
  task_suggestions_title: "Attività consigliate",
  task_suggestions_empty: "Nessun suggerimento in sospeso.",
  task_suggestions_pending_count: "suggerimenti in sospeso",
  task_suggestions_open_page: "Apri suggerimenti",
  task_suggestion_create_task: "Crea attività",
  task_suggestion_dismiss: "Ignora",
  task_suggestion_bulk_create: "Crea selezionate",
  task_suggestion_bulk_dismiss: "Ignora selezionate",
  task_suggestion_bulk_created_success: "Suggerimenti selezionati creati.",
  task_suggestion_bulk_dismissed_success: "Suggerimenti selezionati ignorati.",
  task_suggestion_created: "Creata",
  task_suggestion_created_success: "Attività creata dal suggerimento.",
  task_suggestion_dismissed_success: "Suggerimento ignorato.",
  task_suggestion_health_red: "Rosso",
  task_suggestion_health_yellow: "Giallo",
  task_suggestion_reason_fallback: "Lo stato di salute richiede attenzione.",
  task_suggestion_choose_assignee_title: "Scegli il responsabile",
  task_suggestion_choose_assignee_body:
    "Scegli a chi assegnare l'attività di irrigazione quando accetti questo suggerimento.",
  task_suggestion_choose_assignee_validation: "Seleziona una persona.",
  task_suggestion_bulk_manual_only:
    "In modalità manuale, i suggerimenti di irrigazione possono essere accettati solo uno per volta.",
  select_all: "Seleziona tutto",
  deselect_all: "Deseleziona tutto",
  clear: "Cancella",
  with_sensor: "Con Sensore",
  without_sensor: "Senza Sensore",
  active_installation: "Installazione Attiva",
  no_installation: "Nessuna Installazione",
  filter_by_location: "Filtra per Posizione",
  active_sensor_installation: "Installazione Sensore Attiva",
  irrigation_settings: "Irrigazione",
  irrigation_trigger_conditions: "Condizioni di attivazione",
  irrigation_trigger_yellow: "Attiva quando lo stato salute e giallo",
  irrigation_trigger_red: "Attiva quando lo stato salute e rosso",
  irrigation_trigger_after_days: "Attiva dopo X giorni",
  irrigation_auto_create_task: "Crea automaticamente un'attivita (salta suggerimento)",
  irrigation_suggestion_assignment_mode_title: "Assegnazione per i suggerimenti",
  irrigation_suggestion_assignment_mode_hint:
    "Scegli se i suggerimenti di irrigazione devono usare il responsabile predefinito per area oppure richiedere una selezione manuale a ogni accettazione.",
  irrigation_suggestion_assignment_mode_area_default: "Responsabile predefinito per area",
  irrigation_suggestion_assignment_mode_manual:
    "Scegli manualmente il responsabile a ogni accettazione",
  irrigation_default_volumes: "Volumi di irrigazione predefiniti",
  development_phase: "Fase di sviluppo",
  irrigation_phase_default: "Nessuna fase (predefinito)",
  default_liters: "Litri predefiniti",
  irrigation_interval_title: "Intervallo di irrigazione",
  irrigation_interval_daily: "Giornaliero",
  irrigation_interval_weekly: "Settimanale",
  irrigation_interval_biweekly: "Ogni 2 settimane",
  irrigation_interval_custom: "Personalizzato (X giorni)",
  irrigation_repeat_every: "Ripeti ogni",
  irrigation_stop_condition_title: "Condizione di arresto",
  irrigation_stop_until_green: "Continua finche lo stato salute torna verde",
  irrigation_stop_fixed_cycles: "Numero fisso di cicli",
  irrigation_cycle_count_label: "Numero di cicli di irrigazione",
  irrigation_area_assignees_title: "Responsabile per area",
  irrigation_area_assignees_hint:
    "Definisci chi deve essere assegnato per impostazione predefinita alle attivita di irrigazione create o preparate automaticamente per ciascuna area.",
  irrigation_no_areas: "Nessuna area disponibile.",
  save_settings: "Salva impostazioni",
  irrigation_settings_saved: "Impostazioni di irrigazione salvate.",
  irrigation_validation_custom_days: "Inserisci un intervallo personalizzato valido in giorni.",
  irrigation_validation_fixed_cycles: "Inserisci un numero valido di cicli fissi.",
  files_selected: "File selezionati",
  past_tasks: "Passati",
  future_tasks: "Futuri",
  tree_phases: "Fasi degli alberi",
  health_states_title: "Stato di salute",
  task: "Compito",
  add_task: "Aggiungi compito",
  edit_task: "Modifica compito",
  task_details: "Dettagli compito",
  select_task_types: "Seleziona tipi di compito",
  print_tree_tag: "Stampa etichetta albero",
  tree_photos: "Foto dell'albero",
  leaf_photos: "Foto delle foglie",
  confirm_delete_image: "Sei sicuro di voler eliminare questa immagine?",
  data_science: "Data Science",
  map_view: "Vista Mappa",
  select_project: "Seleziona Progetto",
  choose_project: "Scegli un progetto",
  please_select_project: "Seleziona un progetto per visualizzare i dati",
  please_select_project_to_view_map: "Seleziona un progetto per visualizzare la mappa",
  ds_fetch_error_message:
    "Impossibile caricare i dati delle serie temporali selezionate. L'intervallo di tempo o il numero di sensori selezionati potrebbe essere troppo grande.",
  ds_fetch_error_hint: "Riduci l'intervallo di date, seleziona meno sensori o riprova.",
  ds_pending_reload_message:
    "Il grafico è nascosto perché la selezione è cambiata e i dati non sono ancora stati ricaricati.",
  ds_pending_reload_hint: 'Fai clic su "Load Data" per aggiornare il grafico.',
  ds_no_data_message: "Nessun dato disponibile",
  ds_no_data_hint:
    "Non sono stati trovati valori per i filtri e l'intervallo di tempo selezionati.",
  ds_enter_fullscreen: "Modalità focus",
  ds_exit_fullscreen: "Esci dalla modalità focus",
  no_project_selected: "Nessun progetto selezionato",
  show_tree_list: "Mostra elenco alberi",
  show_all_trees: "Mostra tutti gli alberi",
  all_trees: "Tutti gli alberi",
  no_trees_found: "Nessun albero trovato",
  address: "Indirizzo",
  confirm: "Conferma",
  health_state: "Stato salute dell'albero",
  last_value: "Ultimo valore",
  weather: "Meteo",
  project_details: {
    empty_project: "Progetto vuoto, inizia aggiungendo alberi.",
    empty_trees: "Nessun albero creato, inizia aggiungendo alberi.",
    no_tree_selected: "Seleziona un albero per mostrare i dettagli",
    no_area_selected: "Seleziona un'area per mostrare i dettagli",
    no_sensor_selected: "Selezionare un sensore per visualizzare i dettagli.",
    empty_sensors: "Nessun sensore creato, iniziare aggiungendo sensori.",
  },
  user_details: {
    empty_project: "Nessun utente, inizia aggiungendo alberi.",
    no_user_selected: "Seleziona un utente per mostrare i dettagli",
  },
  sensor_details: {
    empty_sensors: "Nessun sensore, inizia aggiungendo sensori.",
    no_sensor_selected: "Seleziona un sensore per mostrare i dettagli",
    no_data_found: "Nessun dato sensore trovato",
    no_recent_measurements: "Nessuna misurazione negli ultimi 3 mesi.",
    no_recent_measurements_hint:
      "Per controllare dati più vecchi, usa la vista di analisi dei dati e modifica l'intervallo di tempo.",
    no_evaluation_possible: "Nessuna valutazione possibile.",
  },
  sensor: "Sensore",
  sensors: "Sensori",
  sensor_data: "Dati del sensore",
  species: "Specie",
  genus: "Genere",
  actions: "Azioni",
  battery: "Batteria",
  threshold: "Soglia",
  settings: "Impostazioni",
  tour_start: "Avvia Tour",
  help: "Aiuto",
  feedback: "Feedback",
  api_documentation: "Documentazione API",
  wiki_help: "Wiki e Guide",
  without_project: "Senza Progetto",
  without_location: "Senza Posizione",
  no_projects_available: "Nessun progetto disponibile",
  reporting: "Reporting",
  feedback_problem_url: "URL del problema",
  feedback_category: "Categoria",
  feedback_category_bug: "Segnalazione bug",
  feedback_category_positive: "Feedback positivo",
  feedback_category_feature_request: "Richiesta funzionalità",
  feedback_priority: "Priorità",
  feedback_priority_low: "Bassa",
  feedback_priority_medium: "Media",
  feedback_priority_high: "Alta",
  feedback_priority_critical: "Critica",
  feedback_screenshot: "Screenshot",
  feedback_description: "Descrizione",
  send_feedback: "Invia feedback",
  feedback_submit_success: "Feedback salvato con successo.",
  download_excel: "Scarica Excel",
  download_pdf: "Scarica PDF",
  download_csv: "Scarica CSV",
  report_date: "Data",
  report_sensor_tab: "Report sensori",
  report_kataster_tab: "Report catasto",
  report_effect_tab: "Report effetti",
  report_range_1w: "1 settimana",
  report_range_1m: "1 mese",
  report_range_3m: "3 mesi",
  report_range_1y: "1 anno",
  all_areas: "Tutte le aree",
  all_species: "Tutte le specie",
  all_responsible: "Tutti i responsabili",
  report_total_active_sensors: "Sensori attivi",
  report_offline_sensors: "Sensori offline",
  report_avg_moisture_index: "Indice medio di umidità",
  report_critical_trees: "Alberi critici",
  report_batteries_low: "Batterie < 20%",
  report_threshold_violations: "Violazioni soglia",
  report_avg_moisture_over_time: "Indice umidità nel tempo",
  report_health_distribution: "Distribuzione stato salute",
  report_rain_vs_index: "Pioggia vs indice medio",
  report_violations: "Violazioni",
  report_total_trees: "Totale alberi",
  report_controls_performed: "Controlli eseguiti",
  report_overdue_tasks: "Attività scadute",
  report_completed_tasks: "Attività completate",
  report_documented_maintenance: "Interventi documentati",
  report_avg_control_interval: "Intervallo medio di controllo",
  report_task_status_distribution: "Distribuzione stato attività",
  report_controls_per_month: "Controlli per mese",
  report_maintenance_type_distribution: "Distribuzione tipo manutenzione",
  report_critical_with_open_task: "Alberi critici con attività aperta",
  report_avg_violation_to_completion: "Tempo medio da violazione a completamento",
  report_index_change_after_irrigation: "Variazione indice dopo irrigazione",
  report_index_change_after_pruning: "Variazione indice dopo potatura",
  report_before_after_analysis: "Analisi prima/dopo",
  report_before: "Prima",
  report_after: "Dopo",
  report_irrigation_vs_index: "Irrigazioni vs indice medio",
  report_critical_vs_completed: "Alberi critici vs misure completate",
  due_date: "Scadenza",
  reason: "Motivo",
  impact: "Impatto",
  rainfall: "Pioggia",
  index: "Indice",
  completed: "Completato",
  notifications: "Notifiche",
  mark_all_as_seen: "Segna tutti come letti",
  showing: "Mostrando",
  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "L'identificazione univoca del sensore. Si trova sull'adesivo del modulo trasmettitore. Per i sensori LoRaWAN è il DevEUI e per i sensori NB-IoT è l'IMEI.",
  dev_eui: "DevEUI",
  imei: "IMEI",
  add_sensor: "Aggiungi sensore",
  add_user: "Aggiungi utente",
  edit_user: "Modifica utente",
  edit_sensor: "Modifica sensore",
  push_message_notification: "Notifiche push",
  email_notification: "Notifiche via email",
  email_schedule: "Pianificazione email",
  weekly_summary_email: "Email di riepilogo settimanale",
  daily_changes_email: "Email delle modifiche giornaliere",
  manage_users_description: "Gestisci account utente e permessi",
  manage_customers_description: "Gestisci informazioni clienti e accesso",
  statistics: "Statistiche",
  customer_statistics_description: "Visualizza statistiche clienti e panoramica dati",
  go_to_users: "Vai agli Utenti",
  go_to_customers: "Vai ai Clienti",
  tree_with_sensor: "Albero con Sensore",
  represented_tree: "Albero Rappresentato",
  tree_without_sensor: "Albero senza Sensore",
  sensor_status_change_to_no_connection: "Cambio stato sensore a 'nessuna connessione'",
  sensor_status_change_to_dry: "Cambio stato sensore a 'secco'",
  sensor_status_change_to_drying_out: "Cambio stato sensore a 'in via di asciugatura'",
  treespecies: "Specie di albero",
  treegenus: "Genere di albero",
  skip: "Salta",
  notes: "Note",
  latitude: "Latitudine",
  longitude: "Longitudine",
  trunk_circumference: "Circonferenza del tronco",
  crown_diameter: "Diametro della chioma",
  represent_tree: "Rappresenta albero",
  planting_time: "Tempo di piantagione",
  altitude: "Altitudine",
  height: "Altezza",
  location: "Posizione",
  reference: "Riferimento",
  invalid_date: "Data non valida",
  error: {
    this_field_is_required: "Questo campo è obbligatorio",
    name_field_is_required: "Il campo nome è obbligatorio",
    please_choose_species: "Si prega di scegliere la specie",
    please_choose_genus: "Si prega di scegliere il genere",
    choose_location: "Scegli la posizione",
    hardware_serial_no_is_required: "Il numero di serie hardware è obbligatorio",
    a_valid_threshold_is_required: "È necessaria una soglia valida",
    form: "I valori sono stati inseriti in modo errato. Correggerli e riprovare",
    something_went_wrong: "Qualcosa è andato storto",
    loading_customers: "Errore durante il caricamento dei clienti",
    loading_trees: "Errore durante il caricamento degli alberi",
    loading_users: "Errore durante il caricamento degli utenti",
  },
  first_name: "Nome",
  last_name: "Cognome",
  profile: "Profilo",
  Profile: "Profilo",
  Settings: "Impostazioni",
  Manual: "Manuale",
  of: "di",
  the: "il/la",
  Menu: "Menu",
  phone_number: "Numero di telefono",
  account_type: "Tipo di account",
  city: "Città",
  street_name: "Nome della strada",
  house_number: "Numero civico",
  country: "Paese",
  zip_code: "Codice postale",
  day: {
    mon: "Lunedì",
    tue: "Martedì",
    wed: "Mercoledì",
    thu: "Giovedì",
    fri: "Venerdì",
    sat: "Sabato",
    sun: "Domenica",
  },
  end: "Fine",
  admin: "Admin",
  basic: "Base",
  superuser: "Superutente",
  add_existing_tree: "Aggiungi albero esistente",
  phase: "Fase",
  Youngphase: "Fase giovanile",
  Oldphase: "Fase di invecchiamento",
  Midphase: "Fase di maturità",
  select_phase: "Selezionare la fase",
  health_states: {
    wet: "Troppo Bagnato",
    wet_todo: "L'albero o il terreno sembrano troppo umidi e non devono essere annaffiati.",
    healthy: "Sano",
    healthy_todo: "Non è necessario intervenire.",
    medium: "Medio",
    critical: "Critico",
    frost: "Gelo",
    frost_todo: "L'albero potrebbe essere danneggiato dal gelo.",
    dry: "Secco",
    dry_todo: "L'albero deve essere innaffiato o controllato il prima possibile.",
    disconnect: "Disconnetti",
    drying_out: "In via di asciugatura",
    drying_out_todo: "L'albero deve essere innaffiato.",
    unknown: "Sconosciuto",
    unknown_todo: "Il sensore deve essere controllato.",
    too_wet: "Troppo bagnato",
    too_wet_todo: "L'albero o il terreno sembrano troppo umidi e non devono essere annaffiati.",
    no_sensor: "Nessun Sensore",
    no_sensor_todo:
      "Nessun sensore installato. Installare un sensore per monitorare lo stress idrico.",
    no_data: "Nessun Dato",
    no_data_todo:
      "Il sensore è installato ma non invia dati. Controllare la connessione del sensore.",
    maintenance_needed: "Valori del sensore non plausibili",
    maintenance_needed_todo:
      "I valori del sensore sembrano non plausibili. Controllare e manutenere il sensore.",
    priority_title: "Come viene calcolato lo stato?",
    priority_explanation: "Lo stato di salute si basa su un sistema di priorità:",
    priority_1_crown: "Sensori della chioma (se presenti, contano solo questi)",
    priority_2_soil: "Sensori del suolo (solo se non ci sono sensori della chioma)",
    priority_3_dendrometer: "Dendrometro (solo se non ci sono altri sensori)",
    priority_note:
      "💡 Nella vista dettagliata è possibile vedere tutti i sensori. Tuttavia, lo stato dell'albero è determinato solo dalla priorità più alta disponibile.",
    soil_needs_attention: "I sensori del suolo mostrano valori critici anche se la chioma è sana",
    mixed_sensors: "I sensori mostrano stati diversi",
    status_from_crown:
      "Stato basato sul sensore della chioma: {{crownStatus}}\n(Sensore del suolo: {{soilStatus}} - solo informativo)",
    status_from_soil: "Stato basato sul sensore del suolo (nessun sensore della chioma presente)",
    determines_tree_status: "Questo sensore determina lo stato dell'albero",
    info_only: "Solo informativo, non determina lo stato dell'albero",
  },
  tree_water_stress: "Stress idrico",
  tree_status: "Stato dell'albero",
  tree_cadastre_no: "No. catasto albero",
  crown: "Chioma",
  soil: "Suolo",
  overall: "Complessivo",
  health_overview: "Panoramica della salute",
  health_priority: "Priorità",
  note: "Nota",
  active: "attivo",
  defect_sensor: "Sensore difettoso presente",
  defect_sensors_excluded: "I sensori difettosi sono esclusi dal calcolo",
  defect_sensors_info:
    "I sensori difettosi o non raggiungibili (mostrati in grigio) non vengono considerati nel calcolo della salute. Solo i sensori funzionanti contribuiscono allo stato.",
  export: "Esporta",
  export_data: "Esporta dati",
  export_tasks: "Esporta attività",
  export_irrigation_description:
    "Esporta le attività di irrigazione in Excel. Mostra tutte le voci della stagione vegetativa corrente (aprile - ottobre).",
  export_tasks_description:
    "Esporta le attività in Excel. Mostra le attività completate e pianificate raggruppate per albero.",
  no_data_to_export: "Nessun dato da esportare",
  no_tasks_found: "Nessuna attività trovata per i filtri selezionati.",
  problem_in_creating_customer: "Problema nella creazione del cliente",
  problem_in_creating_sensor: "Problema nella creazione del sensore",
  select_customer_type: "Seleziona tipo di cliente",
  assign_to_tree: "Assegna all'albero",
  customer_type: "Tipo di cliente",
  customer_type_agriculture: "Agricoltura",
  customer_type_city: "Città",
  customer_type_forestry: "Silvicoltura",
  customer_type_science: "Scienza",
  import_trees: "Importa alberi",
  choose_file: "Scegli file",
  upload: "Carica",
  choose_the_file_to_be_imported: "Scegli il file da importare",
  upload_tree: "Carica albero",
  change_image: "Cambia immagine",
  update_image: "Aggiorna immagine",
  update_customer_logo_description: "Carica e aggiorna il logo della tua organizzazione",
  tree_added_successfully: "Albero aggiunto con successo",
  change_language: "Cambia lingua",
  appearance: "Aspetto",
  theme: "Tema",
  theme_description: "Scegli come TreeSense appare per te",
  theme_light: "Chiaro",
  theme_light_desc: "Luminoso e chiaro",
  theme_dark: "Scuro",
  theme_dark_desc: "Delicato sugli occhi",
  theme_system: "Sistema",
  theme_system_desc: "Segue il tuo dispositivo",
  current_theme: "Tema attuale",
  language_description: "Seleziona la tua lingua preferita",
  saved: "Salvato",
  total_trees: "Totale alberi",
  total_trees_species: "Totale specie di alberi",
  total_sensors: "Totale sensori",
  critical_sensors: "Sensori critici",
  number_of_tree_on_respective_area: "Numero di alberi nell'area rispettiva",
  number_of_tree_based_on_health_status: "Numero di alberi in base allo stato di salute",
  time: "Tempo",
  maintainance: "Manutenzione",
  type_of_maintenance: "Tipo di manutenzione",
  custom_maintenance_type: "Tipo di manutenzione personalizzato",
  add_your_own_maintenance: "Aggiungi la tua manutenzione",
  disconnected_sensors: "Sensori disconnessi",
  Set_the_report_of_the_project_with_the_help_of_the_pin:
    "Imposta il rapporto del progetto con l'aiuto della spilla",
  sending: "Invio...",
  Dry: "Secco",
  Dryingout: "In via di asciugatura",
  Healthy: "Sano",
  Wet: "Troppo Bagnato",
  Unknown: "Sconosciuto",
  write_something: "Scrivi qualcosa...",
  write_some_notes_on_action_performed: "Scrivi alcune note sull'azione eseguita...",
  resistance: "Resistenza",
  water_soil: "Umidità del suolo",
  dendrometer: "Dendrometro",
  diameter: "Diametro",
  irrigation: "Irrigazione",
  crown_care: "Cura della chioma",
  tree_control: "Controllo dell'albero",
  ligature_control: "Controllo delle legature",
  trunk_protection: "Protezione del tronco",
  tree_stakes_control: "Controllo dei pali dell'albero",
  clearance_profile_pruning: "Potatura del profilo di sgombero",
  deadwood_removal: "Rimozione del legno morto",
  stem_cane_removal: "Rimozione dei gambi",
  topiary: "Topiaria",
  head_purning: "Potatura della testa",
  either_fill_all_address_or_make_all_empty:
    "Riempire tutti i campi dell'indirizzo o lasciarli tutti vuoti",
  search_area: "Cerca aree",
  search_tree: "Cerca albero",
  search_sensor: "Cerca sensore",
  search_sensors: "Cerca sensori...",
  search_trees: "Cerca alberi...",
  showing_results: "Mostrando {{count}} risultati",
  mark_as_Seen: "Segna come Visto",
  tick_the_checkbox_to_download_data: "Seleziona la casella per scaricare i dati",
  download_sensor_data: "Scarica dati del sensore",
  export_sensor_description:
    "Esporta le misurazioni del sensore disponibili per il periodo selezionato.",
  include_advanced_calibration_values: "Includi valori avanzati di calibrazione/debug",
  include_mean_values: "Includi valori medi",
  include_mean_values_hint: "Aggiunge all'esportazione i valori medi per l'intervallo selezionato.",
  sensor_name: "Nome del sensore",
  temperature: "Temperatura",
  rain: "Pioggia",
  loading_data: "Caricamento dati...",
  align_qr_code_within_the_frame: "Allinea il codice QR all'interno del riquadro",
  gallery: "Galleria",
  scan_to_add_sensor: "Scansiona per aggiungere sensore",
  choose_qr_to_scan: "Scegli QR da scansionare",
  pulse_resistance_in_kOhm: "Resistenza agli impulsi in kOhm",
  loading: "Caricamento...",
  irrigationArea: "Area di irrigazione",
  button: {
    back: "Indietro",
    next: "Avanti",
    save: "Salva",
    reset: "Reimposta",
    saving: "Salvando...",
    update: "Aggiorna",
    updating: "Aggiornando...",
    add_tree: "Aggiungi albero",
    add_sensor: "Aggiungi sensore",
    import_tree: "Importa albero",
    add_irrigation_area: "Aggiungi area di irrigazione",
    add_customer: "Aggiungi cliente",
    edit_customer: "Modifica cliente",
    add_all: "Aggiungi tutto",
    cancel: "Annulla",
  },
  choose_location: "Scegli posizione",
  tree_form: {
    sensors: "Sensori",
    position: "Posizione",
    more_info: "Maggiori informazioni",
    tree_profile: "Profilo dell'albero",
    representTree: "Rappresenta Alberi",
    info: {
      represent: {
        heading: "Albero rappresentativo",
        help: "Seleziona l'albero che rappresenta questa posizione per analisi e report.",
        note: "Per analizzare al meglio i dati, consigliamo di caricare un'immagine dell'albero e di una foglia rappresentativa nello stesso momento.",
      },
      sensors: {
        heading: "Sensori",
        help: "Assegna i sensori che appartengono a questo albero.",
        note: "I sensori selezionati vengono utilizzati per mostrare i dati in tempo reale e calcolare le raccomandazioni di irrigazione.",
      },
      soil: {
        heading: "Parametri del suolo",
        max_f_help: "Valore massimo del sensore per alberi ben irrigati (F = irrigati).",
        max_f_label: "Valore massimo (alberi irrigati)",
        max_nf_help: "Valore massimo del sensore per alberi non irrigati (NF = non irrigati).",
        max_nf_label: "Valore massimo (alberi non irrigati)",
        note: "Queste soglie vengono utilizzate per calcolare le raccomandazioni di irrigazione e i colori del semaforo.",
        pwp_help:
          "Valore del sensore in cui l'albero raggiunge il punto di avvizzimento permanente (PWP).",
        pwp_label: "Punto di avvizzimento permanente (PWP)",
      },
    },
  },
  user_form: {
    profile: "Profilo",
    address: "Indirizzo",
    basic_info: "Informazioni di base",
    login_credentials: "Credenziali di accesso",
    areas: "Aree",
  },
  sensor_form: {
    name: "Nome",
    threshold: "Soglia",
    hardware_serial: "Numero di serie hardware",
    sensor_type: "Tipo di sensore",
    network_type: "Tipo di rete",
  },
  task_form: {
    basic_info: "Informazioni di base",
    assignment: "Assegnazione",
    title: "Titolo",
    title_placeholder: "Inserisci titolo compito",
    description: "Descrizione",
    description_placeholder: "Inserisci descrizione compito",
    priority: "Priorità",
    priority_low: "Bassa",
    priority_medium: "Media",
    priority_high: "Alta",
    status: "Stato",
    status_pending: "In attesa",
    status_in_progress: "In corso",
    status_completed: "Completato",
    tree: "Albero",
    assigned_to: "Assegnato a",
    due_date: "Data di scadenza",
    created_at: "Creato il",
    created_by: "Creato da",
    select_task_to_view: "Seleziona un compito per visualizzare i dettagli",
    select_user: "Seleziona utente",
  },
  area_form: {
    existing_area: "Area esistente",
  },
  add_all_form: {
    title: "Aggiungi Albero e Sensore in Area",
    sensor: {
      title: "Sensore",
      explanation:
        "Qui puoi creare un nuovo sensore da aggiungere all'albero, oppure selezionare un sensore esistente da aggiungere.",
      new_sensor: "Crea un nuovo sensore",
      existing_sensors: "Aggiungi sensori esistenti",
    },
    tree: {
      title: "Albero",
      explanation: "Qui puoi creare un nuovo albero o selezionarne uno esistente.",
      new_tree: "Crea un nuovo albero",
      existing_tree: "Seleziona un albero esistente",
    },
    area: {
      title: "Area",
      explanation:
        "Qui puoi creare una nuova area o selezionarne una esistente a cui aggiungere l'albero.",
      new_area: "Crea una nuova area",
      existing_area: "Seleziona un'area esistente",
    },
  },
  new_area: "Nuova area",
  existing_area: "Area esistente",
  explanation: "Spiegazione",
  create_new_tree: "Crea nuovo albero",
  validation: {
    email_is_required: "L'email è richiesta",
    password_is_required: "La password è richiesta",
    invalid_email_address: "Indirizzo email non valido",
    name_is_required: "Il nome è richiesto",
    hardware_serial_is_required: "Il numero di serie hardware è richiesto",
    user_with_this_email_already_exist: "Un utente con questa email esiste già",
    all_address_field_are_required: "Tutti i campi dell'indirizzo sono richiesti",
    position_is_required: "La posizione è richiesta",
    invalid_house_number: "Numero di casa non valido",
    user_limit_exceeded_for_your_package: "Limite di utenti superato per il vostro pacchetto",
    sensor_limit_exceeded_for_your_package: "Superamento del limite del sensore per il pacchetto",
    tree_limit_exceeded_for_your_package: "Limite di alberi superato per il vostro pacchetto",
    invalid_hex_identifier:
      "L'identificatore deve essere un valore esadecimale valido in maiuscolo. Utilizzare solo cifre 0–9 e lettere maiuscole A–F.",
    imei_must_be_15_digits: "L'IMEI deve contenere esattamente 15 cifre.",
    hardware_serial_must_be_16_characters:
      "Il numero di serie dell'hardware deve essere esattamente di 16 caratteri.",
    must_be_a_number: "Il valore deve essere un numero",
    out_of_range: "Il valore deve essere compreso tra {{min}} e {{max}}",
    task_error: "L'attività è obbligatoria.",
    cadastre_or_name_required:
      "È necessario fornire il numero catastale dell'albero o il nome dell'albero.",
    either_field_required: "* È necessario compilare almeno uno di questi campi.",
    required_fields: "* Campi obbligatori",
    this_field_is_required: "Questo campo è obbligatorio",
    project_name_required: "Il nome del progetto è obbligatorio",
    project_name_max_length: "Il nome del progetto non può superare i 100 caratteri",
    project_start_required: "L'inizio del progetto è obbligatorio",
    area_required: "L'area è obbligatoria",
  },
  drag_the_below_variables_to_graph_area: "Trascina le variabili sottostanti nell'area del grafico",
  drop_left: "Rilascia a sinistra",
  drop_right: "Rilascia a destra",
  drop_the_variable_to_get_data: "Rilascia la variabile per ottenere i dati",
  no_data_available_please_check_data_available_to_this_date:
    "Nessun dato disponibile, si prega di controllare i dati disponibili a questa data",
  unable_to_upload_file: "Impossibile caricare il file",
  file_upload_successfully: "File caricato con successo",
  no_tree_is_selected: "Nessun albero selezionato",
  no_sensor_is_selected: "Nessun sensore selezionato",
  areaName: "Nome dell'area",
  childTree: "Albero secondario",
  add_child_tree: "Aggiungi albero secondario",
  parentTree: "Albero principale",
  area: "Area",
  areas: "Aree",
  add_area: "Aggiungi area",
  start_with_adding_new_project: "Inizia aggiungendo un nuovo progetto",
  resis_temp_comp: "Compensazione temperatura resis",
  health_of_tree_is_good: "La salute dell'albero è buona",
  health_of_tree_is_drying_out: "La salute dell'albero si sta esaurendo",
  health_of_tree_is_poor: "La salute dell'albero è scarsa",
  sensor_disconnect: "Sensore disconnesso",
  battery_full: "Batteria piena",
  less_than_60_of_the_battery_remaining: "Meno del 60% della batteria rimanente",
  battery_is_getting_low: "La batteria si sta esaurendo",
  size: "Dimensione",
  type: "Tipo",
  records: "Record",
  pagination_out_of: "di",
  status: "Stato",
  welcome_back: "Bentornato!",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Sembra che tu non abbia selezionato un'area, seleziona un'area per ottenere i dati",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "Sembra che tu non abbia selezionato un albero, seleziona un albero per ottenere i dati",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Sembra che tu non abbia selezionato un sensore, seleziona un sensore per ottenere i dati",
  please_drag_the_variable_to_display_data: "Trascina la variabile per visualizzare i dati",
  click_on_marker_to_select_tree: "Clicca sul marcatore per selezionare l'albero",
  next_irrigation: "Prossima irrigazione",
  mean: "Media",
  default: "Predefinito",
  default_legacy: "Predefinito, legacy",
  sensor_state: "Stato del sensore",
  state: "Stato",
  moisture_content: "Indice di umidità Treesense",
  drought_days: "Giorni di siccità",
  formula_type: "Formula",
  calibration_species: "Specie di calibrazione",
  calibration_species_tooltip:
    "Il modello di calibrazione utilizzato per questa specie per calcolare l'indice di umidità",
  calibration_species_no_mapping: "Nessuna mappatura della specie disponibile",
  calibration_species_unknown_tree_species: "Specie dell'albero mancante",
  calibration_species_legacy_settings_hint:
    "Viene utilizzata la vecchia calibrazione del pioppo nero.",
  calibration_species_settings_hint:
    "Se qui non viene mostrata alcuna mappatura o se è ancora attiva la formula legacy, puoi aggiornarla in Impostazioni > Cliente > Formula del contenuto di umidità.",
  calibration_species_settings_link: "Apri impostazioni",
  card_number: "Numero della carta",
  card_name: "Nome sulla carta",
  expiration_date: "Data di scadenza",
  continue: "Continua",
  today: "Oggi",
  tomorrow: "Domani",
  days_left: "giorni rimasti",
  days: "Giorni",
  personal_data: "Dati personali",
  basic_user_projects_hint:
    "Qui puoi assegnare interi progetti. Tutte le aree/posizioni appartenenti ai progetti selezionati saranno incluse.",
  basic_user_areas_hint:
    "Gli utenti Basic dovrebbero essere assegnati a una o più aree/posizioni. Senza assegnazioni, il loro accesso ai dati è limitato.",
  user_invitation_email_hint:
    "Dopo il salvataggio, l'utente riceverà un'email per impostare la propria password.",
  persona_labels: {
    tree_inspector: "Ispettore degli alberi",
    irrigation_team: "Team di irrigazione",
    city_tree_manager: "Responsabile del patrimonio arboreo urbano",
    research_partner: "Partner di ricerca",
    treesense_support: "Supporto TreeSense",
  },
  settings_user_info: {
    persona_section_title: "Cosa cambia nell'interfaccia",
    role_section_title: "Cosa cambia negli accessi",
    persona_footer:
      "Le personas definiscono il punto di ingresso predefinito e il focus UX. Gli accessi effettivi continuano a dipendere dai permessi del ruolo nel backend.",
    role_footer:
      "I ruoli determinano i permessi effettivi. Le personas influenzano solo la navigazione predefinita e il focus UX.",
    persona: {
      tree_inspector: {
        description:
          "Profilo UX per utenti che lavorano principalmente nel catasto arboreo e svolgono ispezioni sul campo.",
        changes: [
          "Pagina predefinita: Catasto arboreo",
          "Focus: ispezioni, dati degli alberi e lavoro sul campo",
        ],
      },
      irrigation_team: {
        description:
          "Profilo UX per utenti che lavorano soprattutto in flussi operativi di irrigazione ed esecuzione.",
        changes: [
          "Pagina predefinita: Attività",
          "Focus: flussi di irrigazione ed esecuzione operativa",
        ],
      },
      city_tree_manager: {
        description:
          "Profilo UX per utenti che necessitano di una vista gestionale su dashboard, catasto e analisi.",
        changes: [
          "Pagina predefinita: Dashboard",
          "Focus: panoramica, catasto e attività orientate al reporting",
        ],
      },
      research_partner: {
        description:
          "Profilo UX per utenti che lavorano principalmente in Data Science e nell'analisi basata sui sensori.",
        changes: [
          "Pagina predefinita: Data Science",
          "Focus: esplorazione, dati dei sensori e analisi",
        ],
      },
      treesense_support: {
        description:
          "Profilo UX per utenti che monitorano i sensori e gestiscono processi di supporto tecnico.",
        changes: [
          "Pagina predefinita: Sensori",
          "Focus: stato dei sensori e workflow di supporto tecnico",
        ],
      },
    },
    role: {
      superuser: {
        description:
          "Ruolo amministrativo completo con accesso illimitato alle aree di configurazione e gestione.",
        changes: [
          "Può gestire utenti, impostazioni e amministrazione a livello cliente",
          "Ha in genere l'accesso più ampio tra i moduli",
        ],
      },
      admin: {
        description:
          "Ruolo amministrativo per la gestione a livello cliente e i flussi organizzativi.",
        changes: [
          "Può gestire i flussi organizzativi senza piena responsabilità della piattaforma",
          "Di solito ha un accesso ampio a livello cliente, in base ai permessi backend",
        ],
      },
      basic: {
        description:
          "Ruolo operativo per l'uso quotidiano all'interno di progetti e aree assegnati.",
        changes: [
          "Lavora all'interno di progetti e aree assegnati",
          "Le assegnazioni alle aree sono particolarmente rilevanti per l'accesso operativo",
        ],
      },
    },
  },
  language: "Lingua",
  change_logo: "Cambia logo",
  role: "Ruolo",
  demo_project_warning: {
    title: "Account Demo",
    description:
      "Stai utilizzando un account demo e hai diritti limitati. Se sei già un cliente e desideri accedere al tuo account cliente, contatta il supporto all'indirizzo support@treesense.net. Se non sei ancora un cliente, puoi ordinare sensori tramite il nostro negozio su https://www.treesense.net.",
  },
  add_tree_img: "Carica immagini dell'albero",
  datetime_photo: "Data e ora della foto",
  upload_tree_img: "Carica immagine dell'albero",
  upload_leaf_img: "Carica immagine della foglia",
  upload_3d_model: "Carica modello 3D",
  replace_3d_model: "Sostituisci modello 3D",
  remove_3d_model: "Rimuovi modello 3D",
  pulse_sensor: "Sensore a impulsi",
  soil_moisture_sensor: "Sensore di umidità del suolo",
  dendrometer_sensor: "Dendrometro",
  tilt_sensor: "Sensore di inclinazione",
  roll: "Rollio",
  pitch: "Beccheggio",
  tilt_roll: "Angolo di rollio",
  tilt_pitch: "Angolo di beccheggio",
  tilt_threshold: "Soglia di inclinazione",
  tilt_alarm: "Allarme inclinazione",
  tilt_alarm_active: "Attivo",
  tilt_alarm_inactive: "Nessun allarme",
  tilt_alarm_email: "Email allarme inclinazione",
  task_notification_email: "Email assegnazione attività",
  tilt_calibrate: "Azzerare",
  calibrating: "Calibrazione in corso...",
  tilt_calibrate_confirm: "Impostare la posizione attuale come punto zero?",
  characters: "Caratteri",
  maximum_of: "Massimo",
  stop_scanning: "Interrompere la Scansione",
  last_measurements: "Ultime misurazioni",
  adjust_thresholds_crown: "Regolazione delle soglie dei sensori a corona",
  adjust_thresholds_soil: "Regolare le soglie dei sensori del terreno",
  set_default: "Impostare l'impostazione predefinita",
  meaning_measurement: "Significato della misura",
  download_tree_list: "Scarica l'elenco degli alberi",
  download_tree_details: "Scarica i dettagli dell'alberi",
  not_provided: "Non fornito",
  soil_moisture_edit: "Valori limite umidità vol. del suolo",
  soil_water_tension_edit: "Valori limite per la tensione di aspirazione del terreno",
  select_language: "Seleziona la Lingua",
  login_credentials: "Dati di Accesso",
  planting_year: "Anno di piantagione",
  select_year: "Seleziona anno",
  network_type: "Tipo di rete",
  sensor_type: "Tipo di sensore",
  lora_wan: "LoRaWAN",
  nb_iot: "NB-IoT",
  battery_empty: "Batteria scarica",
  maintenance_needed: "Valori del sensore non plausibili",
  All: "Tutti",
  tree_count: "Numero di alberi",
  soil_moisture: "Umidità del suolo",
  soil_moisture_vg: "Umidità del suolo (van Genuchten)",
  soil_water_tension_sensor: "Sensore di tensione di suzione del suolo",
  soil_water_tension: "Tensione di suzione del suolo",
  soil_water_tension_vg: "Tensione di suzione del suolo (van Genuchten)",
  views_per_page: "Visite per pagina",
  customer_attributes: "Attributi cliente",
  tree_profile: {
    tree_species_knowledge: "Fatti",
    tree_species: "Curiosità",
    tree_info: "Informazioni sull'albero",
    learn_more: "Clicca qui per saperne di più",
  },
  root_system: {
    UN: "Sconosciuto",
    SH: "Radici superficiali",
    DE: "Radici profonde",
    HE: "Radici a cuore",
  },
  latin_name: "lat. Nome",
  german_name: "dt. Nome",
  tree_species: "Specie dell'albero",
  depth: "Profondità",
  root_ball: "Zolla radicale",
  healthy: "Sano",
  okay: "Okay",
  critical: "Critico",
  not_sending: "Non invia dati",
  working: "Funziona",
  unknown: "Sconosciuto",
  defect: "Difettoso",
  amount_nodes: "Numero di nodi sensore",
  add_installation: "Creare installazione",
  select_sensor: "Selezionare sensore",
  select_depth: "Selezionare profondità",
  installed_at: "Data di installazione",
  removed_at: "Data di rimozione",
  last_battery: "Ultimo valore della batteria",
  hardware_serial_no: "Hardware Seriale",
  required_information: "* Informazioni obbligatorie",
  last_10_measurements: "Ultimi 10 valori misurati",
  soil_name: "Nome del suolo",
  optional_soil_name: "Nome del suolo (opzionale)",
  tree_name: "Nome dell'albero",
  permanent_wilting_point: "Punto di appassimento permanente",
  effective_field_capacity: "Capacità di campo utile",
  field_capacity: "Capacità di campo",
  sensor_status: "Stato del sensor",
  sensor_status_description:
    "Lo stato del sensore indica se il sensore funziona o se necessita di manutenzione, ad esempio.",
  timeframe: "Intervallo di tempo",
  timeframe_hint:
    "Lascia invariato per scaricare gli ultimi 30 giorni. Modifica l'intervallo per restringere l'esportazione.",
  include_new_moisture_content_data: "Includi il nuovo indice di umidita (species mapping)",
  include_old_moisture_content_data: "Includi il vecchio indice di umidita (schwarzpappel)",
  include_species_mapping_data: "Includi inoltre i dati di calibrazione species mapping",
  file_download_success: "Il file e stato scaricato con successo.",
  export_failed: "Esportazione non riuscita. Riprova.",
  no_data_for_selected_range:
    "Nessun dato disponibile per l'intervallo di tempo e i parametri selezionati.",
  invalid_date_range: "La data di inizio deve essere precedente alla data di fine.",
  one_year: "1 Anno",
  six_months: "6 Mesi",
  three_weeks: "3 Settimane",
  one_week: "1 Settimana",
  one_day: "1 Giorno",
  custom_range: "Intervallo",
  open_time_controls: "Apri controlli temporali",
  close_time_controls: "Chiudi controlli temporali",
  filters: "Filtri",
  data_interval_settings: "Impostazioni intervallo dati",
  data_interval_description: "Specifica come raggruppare i punti dati nel grafico.",
  close: "Chiudi",
  traffic_safety_assessments: "Valutazioni di Sicurezza Stradale",
  add_assessment: "Aggiungi Valutazione",
  edit_safety_assessment: "Modifica Valutazione di Sicurezza",
  add_safety_assessment: "Aggiungi Valutazione di Sicurezza",
  no_safety_assessments: "Nessuna valutazione di sicurezza registrata",
  traffic_safety_status: "Stato di Sicurezza Stradale",
  defect_types: "Tipi di Difetto",
  structural_defects: "Difetti Strutturali",
  root_defects: "Difetti Radicali",
  trunk_defects: "Difetti del Tronco",
  crown_defects: "Difetti della Chioma",
  fungal_infection: "Infezione Fungina",
  pest_infestation: "Infestazione Parassitaria",
  safety_status: {
    safe: "Sicuro",
    monitoring_required: "Monitoraggio Richiesto",
    action_required: "Azione Richiesta",
    unsafe: "Non Sicuro",
  },
  risk_level: {
    low: "Rischio Basso",
    medium: "Rischio Medio",
    high: "Rischio Alto",
    critical: "Rischio Critico",
  },
  vta_assessments: "Valutazioni VTA",
  add_vta: "Aggiungi VTA",
  edit_vta: "Modifica VTA",
  no_vta_assessments: "Nessuna valutazione VTA registrata",
  assessor: "Valutatore",
  vitality_stage: "Stadio di Vitalità",
  vitality_stage_help:
    "0 = Vitale, 1 = Leggermente indebolito, 2 = Indebolito, 3 = Gravemente indebolito",
  crown_vitality: "Vitalità della Chioma",
  dieback: "Deperimento",
  damage_severity_label: "Gravità del Danno",
  bark_condition_label: "Condizione della Corteccia",
  growth_rate_label: "Tasso di Crescita",
  damage_severity: {
    none: "Nessuno",
    light: "Leggero",
    moderate: "Moderato",
    severe: "Grave",
    critical: "Critico",
  },
  bark_condition: {
    healthy: "Sana",
    minor_damage: "Danni Minori",
    moderate_damage: "Danni Moderati",
    severe_damage: "Danni Gravi",
  },
  foliage_density: {
    full: "Pieno",
    moderate: "Moderato",
    sparse: "Rado",
    very_sparse: "Molto Rado",
  },
  growth_rate: {
    vigorous: "Vigoroso",
    normal: "Normale",
    slow: "Lento",
    stagnant: "Stagnante",
  },
  inspections: "Ispezioni",
  add_inspection: "Aggiungi Ispezione",
  edit_inspection: "Modifica Ispezione",
  no_inspections: "Nessuna ispezione registrata",
  inspection_date: "Data Ispezione",
  inspection_type_label: "Tipo di Ispezione",
  inspection_result_label: "Risultato Ispezione",
  findings: "Rilevamenti",
  action_required: "Azione Richiesta",
  action_priority: "Priorità Azione",
  next_inspection: "Prossima Ispezione",
  overdue: "Scaduto",
  inspection_type: {
    routine: "Routine",
    safety: "Sicurezza",
    detailed: "Dettagliata",
    emergency: "Emergenza",
    post_storm: "Post-Tempesta",
  },
  inspection_result: {
    passed: "Superato",
    passed_with_notes: "Superato con Note",
    failed: "Non Superato",
  },
  priority: {
    low: "Bassa",
    medium: "Media",
    high: "Alta",
    urgent: "Urgente",
  },
  tree_info: "Info Albero",
  photos: "Foto",
  no_photos: "Nessuna foto caricata",
  add_photo: "Aggiungi Foto",
  all_projects: "Tutti i Progetti",
  favorites: "Preferiti",
  new_project: "Nuovo Progetto",
  trees_short: "Alberi",
  tree_cadastre: "Catasto Alberi",
  sensors_monitoring: "Sensori & Monitoraggio",
  tasks_workflows: "Compiti & Flussi di Lavoro",
  reports_analysis: "Rapporti & Analisi",
  new_task: "Nuova attività",
  search_tasks: "Cerca attività...",
  filter_tasks: "Filtri",
  reset_filters: "Reimposta",
  task_filter_measure_type: "Tipo attività",
  task_filter_pruning_type: "Tipo di potatura",
  task_filter_due_period: "Periodo",
  task_filter_today: "Oggi",
  task_filter_this_week: "Questa settimana",
  task_filter_this_month: "Questo mese",
  task_filter_overdue: "In ritardo",
  measure_type_inspection: "Controllo periodico",
  measure_type_irrigation: "Irrigazione",
  measure_type_pruning: "Potatura",
  measure_type_free_entry: "Voce libera",
  measure_type_sensor_maintenance: "Manutenzione sensore",
  measure_type_soil_maintenance: "Manutenzione del suolo",
  view_kanban: "Kanban",
  view_list: "Lista",
  view_calendar: "Calendario",
  stats_total: "Attività totali",
  stats_in_progress: "In corso",
  stats_completed: "Completate",
  stats_overdue: "In ritardo",
  status_planned: "Pianificata",
  status_in_progress: "In corso",
  status_review: "In revisione",
  status_completed: "Completata",
  status_GEPLANT: "Pianificato",
  status_BEAUFTRAGT: "Incaricato",
  status_IN_ARBEIT: "In corso",
  status_ERLEDIGT: "Completato",
  status_NICHT_GESCHAFFT: "Non completato",
  priority_low: "Bassa",
  priority_medium: "Media",
  priority_high: "Alta",
  task_title: "Titolo",
  task_title_placeholder: "Inserisci il titolo",
  task_description: "Descrizione",
  task_description_placeholder: "Inserisci la descrizione",
  task_assignee: "Assegnato a",
  task_assignee_select_placeholder: "Seleziona la persona",
  task_tree_species: "Specie",
  task_tree_species_placeholder: "Inserisci la specie",
  task_tree_location: "Albero e posizione",
  task_tree_info: "Informazioni albero",
  task_tree_select: "Albero",
  task_tree_select_placeholder: "Seleziona albero",
  task_location: "Posizione",
  task_location_placeholder: "Inserisci la posizione",
  task_due_date: "Scadenza",
  task_priority: "Priorità",
  project_name: "Progetto",
  task_status: "Stato",
  task_type: "Tipo di attività",
  task_comments: "Commenti",
  task_attachments: "Allegati",
  task_plan: "Piano attività",
  completed_tasks: "Attività completate",
  planned_tasks: "Attività pianificate",
  next_task: "Prossima attività",
  create_task: "Crea attività",
  delete_task: "Elimina",
  save_changes: "Salva modifiche",
  add_comment: "Aggiungi commento",
  upload_file: "Carica file",
  cancel: "Annulla",
  optional: "facoltativo",
  export_irrigation_tasks: "Esporta attività di irrigazione",
  export_irrigation_tasks_short: "Esporta",
  export_irrigation_tasks_description_v2:
    "Esporta il piano di irrigazione in Excel per un responsabile specifico. Mostra tutte le irrigazioni della stagione vegetativa corrente (aprile - ottobre).",
  export_filter_assignee_hint: "Lascia vuoto per esportare le attività di tutti i responsabili",
  no_irrigation_tasks_found:
    "Nessuna attività di irrigazione trovata per i filtri selezionati. Verifica il responsabile e il periodo.",
  tree_number: "N. albero",
  sensor_installed: "Sensore installato",
  responsible_person: "Responsabile",
  irrigation_abbrev: "Irrig.",
  irrigation_plan: "Piano di irrigazione",
  represented_trees: "Alberi da irrigare congiuntamente",
  no_tasks: "Nessuna attività",
  no_tasks_subtitle: "Crea la tua prima attività",
  no_results: "Nessun risultato",
  no_results_action: "Reimposta filtri",
  tasks_completed_short: "completate",
  more_tasks: "altre",
  month_january: "Gennaio",
  month_february: "Febbraio",
  month_march: "Marzo",
  month_april: "Aprile",
  month_may: "Maggio",
  month_june: "Giugno",
  month_july: "Luglio",
  month_august: "Agosto",
  month_september: "Settembre",
  month_october: "Ottobre",
  month_november: "Novembre",
  month_december: "Dicembre",
  day_monday: "Lun",
  day_tuesday: "Mar",
  day_wednesday: "Mer",
  day_thursday: "Gio",
  day_friday: "Ven",
  day_saturday: "Sab",
  day_sunday: "Dom",
  overview: "Panoramica",
  alerts: "Allarmi",
  tree_inventory: "Inventario Alberi",
  single_tree_view: "Vista Albero Singolo",
  master_data: "Gestione Dati Master",
  documents: "Documenti",
  import_export: "Importa/Esporta",
  live_monitoring: "Monitoraggio Live",
  sensor_configuration: "Configurazione Sensori",
  limits_alerts: "Limiti & Allarmi",
  data_graphs: "Dati & Grafici",
  maintenance: "Manutenzione",
  ticket_system: "Sistema Ticket",
  resource_planning: "Pianificazione Risorse",
  condition_reports: "Rapporti Condizioni",
  cost_analysis: "Analisi Costi",
  development_trends: "Tendenze Sviluppo",
  risk_assessment: "Valutazione Rischi",
  interactive_map: "Mappa Interattiva",
  heatmaps: "Mappe di Calore",
  area_management: "Gestione Aree",
  open_sidebar: "Apri Barra Laterale",
  close_sidebar: "Chiudi Barra Laterale",
  keyboard_shortcuts: "Scorciatoie da Tastiera",
  navigation: "Navigazione",
  general: "Generale",
  menu: "Menu",
  toggle_project_sidebar: "Attiva/Disattiva Barra Progetti",
  toggle_mobile_menu: "Attiva/Disattiva Menu Mobile",
  focus_search: "Focalizza Ricerca",
  show_shortcuts: "Mostra Scorciatoie",
  close_overlays: "Chiudi Sovrapposizioni",
  data_analysis: "Analisi Dati",
  tree_form_info: {
    add_title: "Aggiungi albero",
    edit_title: "Modifica albero",
    profile: {
      heading: "Profilo albero",
      cadastre_label: "N. catastale albero:",
      cadastre_help: "Identificativo opzionale del catasto (max 24 caratteri).",
      name_label: "Nome:",
      name_help: "Nome descrittivo (max 40 caratteri).",
      note: "Questi dati possono essere modificati in seguito nella scheda dell’albero.",
    },
    position: {
      heading: "Posizione",
      latlng_label: "Latitudine / Longitudine*: ",
      latlng_help: "Campi obbligatori. Inserisci le coordinate o posiziona il marker sulla mappa.",
      altitude_label: "Altitudine:",
      altitude_help: "Opzionale. Lascia vuoto se sconosciuta.",
      map_label: "Mappa:",
      map_help:
        "Usa gli strumenti della mappa per zoomare/muovere e impostare la posizione esatta.",
      note: "Coordinate precise migliorano analisi e mappe.",
    },
    more: {
      heading: "Altre informazioni",
      phase_label: "Fase di cura:",
      phase_help: "Seleziona Impianto, Sviluppo o Manutenzione.",
      year_label: "Anno di impianto:",
      year_help: "Seleziona l’anno di messa a dimora.",
      species_label: "Specie arborea:",
      species_help: 'Cerca usando "nome lat. | nome comune".',
      metrics_label: "Metriche:",
      metrics_help: "Circonferenza tronco (cm), altezza (m), diametro chioma (m) — opzionali.",
      note: "Utile per report e raccomandazioni; può essere aggiunto in seguito.",
    },
    sensors: {
      heading: "Sensori",
      help: "Assegna a questo albero i sensori TreeSense esistenti oppure rimuovi le assegnazioni.",
      note: "Le assegnazioni dei sensori possono essere modificate in seguito nella scheda dell’albero.",
    },
    represent: {
      heading: "Albero rappresentativo",
      help: "Opzionale: indica che questo albero rappresenta altri alberi (clustering).",
    },
    soil: {
      heading: "Suolo",
      pwp_label: "PWP:",
      pwp_help: "Punto di appassimento permanente (es. 10).",
      max_nf_label: "Acqua disponibile massima (max_nf):",
      max_nf_help: "Valore tipico, ad es. 25.",
      max_f_label: "Capacità di campo (max_f):",
      max_f_help: "Valore tipico, ad es. 45.",
      note: "Necessario solo se lavori con stime dell’acqua nel suolo.",
    },
  },
  soil_info: {
    heading: "Comprendere i parametri del suolo",
    intro:
      "Questi valori descrivono la capacità di ritenzione idrica del suolo in questa posizione:",
    items: {
      pwp_label: "Punto di appassimento permanente (PWP):",
      pwp_help:
        "Contenuto idrico al di sotto del quale le piante non riescono più ad assorbire acqua e appassiscono.",
      efc_label: "Acqua disponibile (AWC):",
      efc_help:
        "Quantità di acqua effettivamente disponibile per le piante (tra PWP e capacità di campo).",
      fc_label: "Capacità di campo (FC):",
      fc_help: "Massima quantità d’acqua che il suolo trattiene contro la gravità.",
    },
    note: "Questi parametri sono configurati per ciascun sito e influenzano le raccomandazioni di irrigazione.",
  },
  health_state_info: {
    heading: "Semaforo: comprendere il fabbisogno irriguo",
    intro: "Il sistema a semaforo indica a colpo d’occhio se l’albero necessita di irrigazione:",
    states: {
      green_label: "🟢 Verde – Nessuna irrigazione:",
      green_help: "L’albero ha acqua sufficiente.",
      yellow_label: "🟡 Giallo – Irrigazione raccomandata:",
      yellow_help: "Irrigare se logisticamente possibile.",
      red_label: "🔴 Rosso – Irrigazione urgente:",
      red_help: "Irrigare immediatamente!",
      gray_label: "⚪ Grigio – Sconosciuto:",
      gray_help: "Sensore non disponibile o assenza di dati.",
      blue_label: "🔵 Blu – Troppo bagnato:",
      blue_help: "Eccesso d’acqua; rischio di ristagno.",
    },
    note: "Importante: Il segnale si basa su misure e soglie configurate per questo albero, tipo di suolo e sito.",
  },
  pwp_info: {
    heading: "Punto di appassimento permanente (PWP)",
    intro:
      "Il PWP è il contenuto idrico del suolo sotto il quale le piante non riescono più ad assorbire acqua.",
    when_reached: "Quando l’umidità del suolo raggiunge o scende sotto questo valore:",
    bullets: {
      a: "La pianta non assorbe più abbastanza acqua",
      b: "Possono verificarsi danni irreversibili",
      c: "Irrigazione immediata è fondamentale",
    },
    note: "Valori tipici: 10–15% (in base al tipo di suolo)",
  },
  efc_info: {
    heading: "Acqua disponibile (AWC)",
    intro: "L’acqua disponibile è la quantità di acqua effettivamente a disposizione delle piante.",
    formula_intro:
      "Si calcola come differenza tra capacità di campo e punto di appassimento permanente:",
    bullets: {
      a: "AWC = FC − PWP",
      b: "Rappresenta l’acqua disponibile per le piante",
      c: "Importante per la pianificazione dell’irrigazione",
    },
    note: "Valori più alti = il suolo immagazzina più acqua e rifornisce le piante più a lungo",
  },
  fc_info: {
    heading: "Capacità di campo (FC)",
    intro:
      "La capacità di campo è la massima quantità d’acqua trattenuta dal suolo contro la gravità.",
    after_rain: "Dopo irrigazione o pioggia:",
    bullets: {
      a: "L’acqua in eccesso percola",
      b: "Il suolo raggiunge la capacità di campo",
      c: "Meglio intervenire con l’irrigazione prima che si raggiunga il PWP",
    },
    note: "Valori tipici: 35–50% (in base al tipo di suolo)",
  },
  map_sidebar_info: {
    title: "Vista mappa – Aree e alberi",
    heading: "Navigazione nella vista mappa",
    description:
      "Questa barra laterale elenca tutte le aree di irrigazione e i relativi alberi in una vista gerarchica.",
    features_heading: "Funzioni:",
    features: {
      expand_areas_label: "Espandi aree:",
      expand_areas_help: "Clicca su un’area per mostrare tutti gli alberi associati.",
      select_tree_label: "Seleziona un albero:",
      select_tree_help: "Clicca su un albero per visualizzarlo sulla mappa e aprirne i dettagli.",
      add_tree_label: "Aggiungi un albero:",
      add_tree_help: "Usa l’icona “+” per aggiungere nuovi alberi a un’area.",
      parent_child_label: "Relazioni genitore-figlio:",
      parent_child_help:
        "Gli alberi con sensori possono fungere da alberi genitori e rappresentare altri alberi.",
    },
    note: "La codifica a colori degli alberi riflette lo stato di salute (verde = sano, giallo = in essiccazione, rosso = secco, grigio = sconosciuto).",
  },
  filter_by_project: "Filtra per progetto",
  clear_filter: "Cancella filtro",
  date_time: "Data/Ora",
  time_range_selection: "Selezione intervallo temporale",
  time_range_info:
    "Seleziona un intervallo temporale per visualizzare i dati storici. Scegli tra intervalli preimpostati o definisci un periodo personalizzato.",
  one_year_info: "Visualizza i dati degli ultimi 12 mesi",
  six_months_info: "Visualizza i dati degli ultimi 6 mesi",
  three_weeks_info: "Visualizza i dati delle ultime 3 settimane",
  one_week_info: "Visualizza i dati degli ultimi 7 giorni",
  one_day_info: "Visualizza i dati delle ultime 24 ore",
  custom_range_info: "Seleziona un intervallo di data e ora personalizzato",
  reset_chart: "Ripristina grafico",
  reset_info: "Ripristina tutte le impostazioni del grafico ai valori predefiniti",
  interval_settings: "Intervallo",
  other: "Altro",
  project_not_found: "Progetto non trovato",
  tree_water_deficit: "Deficit idrico dell’albero",
  diameter_minus_start: "Variazione del diametro dall’inizio",
  tree_info_help: {
    heading: "Cosa vedi qui",
    description:
      "Questa scheda mostra i dati anagrafici dell’albero selezionato (specie, dimensioni, posizione e stato). Fornisce contesto per i dati dei sensori e la cronologia di manutenzione.",
    fields_heading: "Spiegazione dei campi",
    fields: {
      species_label: "Specie",
      species_help: "Nome scientifico (e nome comune se disponibile).",
      dimensions_label: "Dimensioni",
      dimensions_help:
        "Altezza, diametro della chioma e circonferenza del tronco in base agli ultimi valori registrati nell’inventario.",
      year_phase_label: "Anno di impianto e fase",
      year_phase_help:
        "Anno di impianto (può essere stimato) e fase del ciclo di vita (es. attecchimento, sviluppo, maturità/invecchiamento).",
      location_label: "Posizione",
      location_help:
        "Coordinate (WGS84 latitudine/longitudine) utilizzate per posizionare l’albero sulla mappa.",
      status_label: "Stato dell’albero",
      status_help:
        "Indicatore di stato attuale (es. nessuno stress idrico / stress idrico), in base alle regole del progetto e ai dati disponibili dei sensori.",
    },
    note: "Suggerimento: se hai i permessi, puoi modificare i dati anagrafici tramite l’icona a matita.",
  },
  load_data: "Carica Dati",
  error_loading_customers: "Errore durante il caricamento dei clienti",
  recommendations: "Raccomandazioni",
  error_loading_trees: "Errore durante il caricamento degli alberi",
  error_loading_users: "Errore durante il caricamento degli utenti",
  foliagedensity: "Densità della chioma",
  date: "Data",
  more_actions: "Altre azioni",
  view_on_map: "Apri su mappa",
  view_on_list: "Apri in elenco",
  view_on_chart: "Apri in Data Science",
  tree_and_sensor: "Albero e sensore",
  rainfall_mm: "Pioggia (mm)",
  zoom_in: "Zoom avanti",
  reset_zoom: "Reimposta zoom",
  restore_view: "Ripristina vista",
  data_science_chart_tools: "Strumenti grafico",
  info: "Info",
  download_project_csv: "Scarica dati di progetto (file TSV)",
  download_project_data: "Scarica tutti i dati dei sensori del progetto",
  change: "Modifica",
  download: "Scarica",
  qr_scanner: "Scanner QR",
  select_camera: "Seleziona fotocamera",
  edit_customer: "Modifica cliente",
  cloase_area_list: "Chiudi elenco aree",
  confirm_delete: "Conferma eliminazione",
  create_customer: "Crea cliente",
  downloading: "Download in corso…",
  inspector: "Ispettore",
  installation: "Installazione",
  installed_sensors: "Sensori installati",
  loading_trees: "Caricamento alberi…",
  manage_parent_child_relationships: "Gestisci relazioni padre–figlio",
  manage_trees_without_sensors: "Gestisci alberi senza sensori",
  next_inspection_date: "Data della prossima ispezione",
  no_sensor_mode: "Modalità senza sensori",
  no_trees_available: "Nessun albero disponibile",
  not_found: "Non trovato",
  open: "Apri",
  parent_child_mode: "Modalità padre–figlio",
  proj: "Progetto",
  projects_views: "Progetti",
  reset: "Reset",
  risklevel: "Livello di rischio",
  search: "Cerca",
  search_address: "Cerca indirizzo",
  select_child_trees: "Seleziona alberi figli",
  sensors_views: "Sensori",
  start_scanning: "Avvia scansione",
  treeNoSensor: "Albero senza sensore",
  tree_management_mode: "Modalità gestione alberi",
  trees_views: "Alberi",
  type_an_adress: "Inserisci un indirizzo",
  calculated_values_wip:
    "I valori calcolati (moisture_content, resis_temp_comp) sono ancora in fase di sviluppo. Utilizzali con cautela. Seleziona se vuoi scaricare anche i valori calcolati.",
  creating: "Creazione in corso",
  customer_name: "Nome cliente",
  include_calculated_values: "Includi valori calcolati",
  close_areas_list: "Chiudi elenco aree",
  customer_creation_code: "Codice di creazione cliente",
  value: "Valore",
  variables: "Variabili",
  password_reset_request_sent_generic:
    "Se esiste un account associato a questo indirizzo email, invieremo un link per reimpostare la password.",
  position_confirmed: "Posizione confermata",
  use_my_location: "Usa la mia posizione",
  assessment_date: "Data di valutazione",
  confirm_delete_task_message: "Sei sicuro di voler eliminare questa attività?",
  map_add_tree_mode: "Modalità di posizionamento attiva",
  map_add_tree_hint: "Sposta la mappa per definire la posizione dell'albero.",
  install_sensor: "Installa sensore",
  history: "Storico",
  sesnor_height_hint:
    "Trascina l'icona del sensore o inserisci l'altezza. I valori vengono arrotondati.",
  care_chat: {
    measure_irrigation: "Misura di irrigazione",
    measure_pruning: "Misura di potatura",
    measure_inspection: "Controllo regolare",
    measure_free: "Inserimento libero",
    sensor_install_task: "Montare sensore sull'albero",
    sensor_maintenance_task: "Eseguire manutenzione sensore sull'albero",
    add_entry: "Aggiungi voce",
    fill_checklist: "Compila lista di controllo",
    fill_protocol: "Compila protocollo",
    select_placeholder: "Seleziona",
    back: "Indietro",
    save: "Salva",
    cancel: "Annulla",
    yes: "Sì",
    no: "No",
    responsible_person: "Persona responsabile",
    responsible_person_required: "Persona responsabile (obbligatorio)",
    short_description_optional: "Descrizione breve (opzionale)",
    short_description_placeholder: "Descrizione breve",
    datetime: "Data e ora",
    date: "Data",
    today: "Oggi",
    tomorrow: "Domani",
    in_one_week: "Tra una settimana",
    in_one_month: "Tra un mese",
    time: "Ora",
    remarks: "Note",
    cost_center: "Centro di costo",
    assignment: "Assegnazione",
    description: "Descrizione",
    please_select_person: "Si prega di selezionare una persona.",
    future_date_required: "Seleziona una data e un'ora future.",
    please_provide_type: "Si prega di indicare il tipo.",
    please_provide_tree_condition: "Si prega di indicare la condizione dell'albero.",
    weather_sunny: "soleggiato",
    weather_cloudy: "nuvoloso",
    weather_rain_before: "pioggia prima",
    weather_rain_after: "pioggia dopo",
    weather_windy: "ventoso",
    weather_dry: "secco",
    soil_dry: "secco",
    soil_slightly_moist: "leggermente umido",
    soil_wet: "bagnato",
    tree_condition_healthy: "sano",
    tree_condition_wilted_leaves: "foglie appassite",
    tree_condition_damage: "danni",
    tree_condition_tilt: "inclinazione",
    tree_condition_other: "altro",
    irrigation_protocol_title: "Compila protocollo di irrigazione",
    water_amount_liters: "Quantità d'acqua (litri)",
    water_amount_required: "Inserisci la quantità d'acqua.",
    irrigation_method: "Metodo di irrigazione",
    irrigation_method_placeholder: "es. manuale, sacchetto d'acqua, autocisterna",
    reason: "Motivo / occasione",
    reason_placeholder: "regolare, siccità, ...",
    weather_conditions: "Condizioni meteorologiche",
    soil_moisture: "Umidità del suolo",
    tree_condition: "Condizione dell'albero",
    tree_condition_required: "Condizione dell'albero (obbligatorio)",
    tree_condition_placeholder: "es. sano, danni, infezione fungina",
    pruning_protocol_title: "Compila protocollo di potatura",
    pruning_type: "Tipo di misura di potatura",
    pruning_type_required: "Tipo di misura di potatura (obbligatorio)",
    pruning_formative: "Potatura formativa",
    pruning_maintenance: "Potatura di manutenzione",
    pruning_crown_reduction: "Riduzione della chioma / cura della chioma",
    pruning_clearing: "Sgombero / disboscamento",
    pruning_remedial: "Potatura di risanamento (ripristino / correzione)",
    pruning_safety: "Potatura di sicurezza (sicurezza stradale)",
    inspection_title: "Documenta controllo regolare",
    inspection_data: "Dati di controllo",
    inspected_by: "Controllato da",
    interval_years: "Intervallo (anni)",
    next_inspection: "Prossimo controllo",
    road_safe: "Sicurezza stradale",
    further_action_title: "Ulteriori azioni",
    action_required: "Necessità di intervento",
    consult_specialist: "Consultazione con reparto specializzato",
    detailed_investigation: "Indagini approfondite",
    tree_care_measures: "Misure di cura dell'albero",
    tree_care_measures_hint: "es. rimozione legno secco, potatura profilo, stabilizzazione chioma",
    inspection_intervals: "Intervalli di controllo",
    interval_future_every: "in futuro ogni",
    interval_years_annual: "anni / annualmente",
    interval_as_before: "come prima",
    felling: "Abbattimento",
    completion: "Esecuzione",
    immediately: "immediatamente",
    within: "entro",
    weeks: "settimane",
    remarks_label: "Osservazioni",
    fill_form: "Compila modulo",
    upload_document: "Carica documento",
    upload_document_hint: "Trascina PDF, immagine o documento qui, oppure clicca per selezionare",
    remove: "Rimuovi",
    follow_up_inspection: "Controllo regolare (seguito)",
    remark_optional: "Nota (opzionale)",
    status_planned: "Pianificato",
    status_commissioned: "Commissionato",
    status_in_progress: "In corso",
    status_done: "Completato",
    status_not_done: "Non completato",
    priority: "Priorità",
    priority_low: "Bassa",
    priority_medium: "Media",
    priority_high: "Alta",
    priority_critical: "Critico",
    amount: "Quantità:",
    method: "Metodo:",
    cut_type: "Tipo di taglio:",
    scope: "Portata:",
    inspection_level: "Livello di controllo:",
    finding: "Riscontro:",
    recommendation: "Raccomandazione:",
    reason_display: "Motivo:",
    executor: "Esecutore:",
    deadline: "Scadenza:",
    cost_center_display: "Centro di costo:",
    assignment_display: "Assegnazione:",
    description_display: "Descrizione:",
    irrigation_log_title: "Protocollo di irrigazione",
    datetime_display: "Data / Ora:",
    water_amount_display: "Quantità d'acqua:",
    irrigation_method_display: "Metodo di irrigazione:",
    reason_label: "Motivo / occasione:",
    weather_display: "Condizioni meteorologiche:",
    soil_moisture_display: "Umidità del suolo:",
    tree_condition_display: "Condizione dell'albero:",
    responsible_person_display: "Persona responsabile:",
    remarks_display: "Note:",
    pruning_log_title: "Protocollo di potatura",
    pruning_type_display: "Tipo:",
    inspected_by_display: "Controllato da:",
    inspection_date_display: "Data di controllo:",
    next_inspection_display: "Prossimo controllo:",
    interval_display: "Intervallo:",
    road_safe_display: "Sicurezza stradale:",
    remark_display: "Nota:",
    attachment_display: "Allegato:",
    show_less: "Mostra meno",
    show_more: "Mostra di più",
    all_statuses: "Tutti gli stati",
    all_priorities: "Tutte le priorità",
    all_types: "Tutti i tipi",
    sort_by_date: "Ordina per data",
    sort_by_priority: "Ordina per priorità",
    add_photo: "Aggiungi foto",
    no_entries_found: "Nessuna voce trovata.",
    no_tasks_found: "Nessun compito trovato.",
    next_inspection_label: "Prossimo controllo:",
    no_inspection_planned: "Nessun controllo pianificato.",
    plan_inspection: "Pianifica controllo",
    perform_inspection: "Esegui controllo",
    delete: "Elimina",
    appointment_label: "Appuntamento:",
    edit: "Modifica",
    mark_not_done: "Segna come non completato",
    mark_done: "Segna come completato",
    favorite: "Preferito",
    reschedule: "Riprogramma",
    reschedule_title: "Riprogramma appuntamento",
    overdue_since_days: "In ritardo di {{days}} giorni",
    in_days: "Tra {{days}} giorni",
    overdue_since_hours: "In ritardo di {{hours}} ore",
    in_hours: "Tra {{hours}} ore",
  },
  change_position: "Cambia  posizione",
  remove: "Rimuovi",
  water_stress: "Stress idrico",
  install: "Installa",
  thresholds: "Soglie",
  thresholds_select_one_sensor: "Selezionare esattamente un sensore per visualizzare le soglie.",
  cookie_consent: {
    banner_title: "Impostazioni Cookie",
    banner_description:
      "Utilizziamo i cookie per offrirti la migliore esperienza possibile sul nostro sito web. Puoi personalizzare le tue preferenze o accettare tutti i cookie.",
    accept_all: "Accetta Tutti",
    accept_essential: "Solo Essenziali",
    customize: "Personalizza",
    save_preferences: "Salva Preferenze",
    essential_cookies: "Cookie Essenziali",
    essential_cookies_description:
      "Questi cookie sono essenziali per il funzionamento del sito web e non possono essere disabilitati. Vengono generalmente impostati solo in risposta ad azioni da te effettuate, come l'impostazione delle tue preferenze sulla privacy, l'accesso o la compilazione di moduli.",
    analytics_cookies: "Cookie Analitici",
    analytics_cookies_description:
      "Questi cookie ci consentono di contare le visite e le fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito web. Ci aiutano a capire quali pagine sono più popolari e come i visitatori si muovono nel sito.",
    marketing_cookies: "Cookie di Marketing",
    marketing_cookies_description:
      "Questi cookie possono essere impostati dai nostri partner pubblicitari attraverso il nostro sito web. Possono essere utilizzati per creare un profilo dei tuoi interessi e mostrarti pubblicità pertinente su altri siti web.",
    preferences_cookies: "Cookie di Preferenza",
    preferences_cookies_description:
      "Questi cookie consentono al sito web di ricordare le tue scelte (come il tuo nome utente, la lingua o la regione in cui ti trovi) e fornire funzionalità avanzate e più personalizzate.",
    cookie_policy: "Politica sui Cookie",
    privacy_policy: "Informativa sulla Privacy",
    settings_title: "Impostazioni Cookie",
    settings_description:
      "Gestisci le tue preferenze sui cookie. Le modifiche avranno effetto immediatamente.",
    last_updated: "Ultimo aggiornamento",
    preferences_saved: "Le tue preferenze sui cookie sono state salvate.",
    preferences_error: "Errore nel salvataggio delle preferenze.",
  },
  tree_wiki: "Wiki dell'albero",
  sensor_already_installed: "Questo sensore è già installato attivamente.",
  please_select_sensor: "Si prega di selezionare un sensore.",
  installation_save_failed: "Impossibile salvare l'installazione. Riprova.",
  beta_ended: {
    title: "Fase Beta Terminata",
    subtitle: "La fase di test è finita",
    description:
      "Grazie per aver utilizzato la versione beta! Tutte le modifiche e i miglioramenti della fase beta sono stati implementati e sono ora disponibili nella TreeSense Cloud.",
    link_text: "Vai a TreeSense Cloud",
  },
  improvements: "Miglioramenti",
  moisture_formula_setting: "Formula del Contenuto di Umidità",
  use_new_moisture_formula: "Usa nuova formula",
  moisture_formula_hint:
    "La nuova formula compensa meglio gli effetti della temperatura e fornisce valori più stabili.",
  new_formula: "Nuova Formula",
  old_formula: "Vecchia Formula",
  moisture_formula_new_description:
    "Generalmente più stabile poiché compensa meglio gli effetti della temperatura. Tuttavia, ciò può rendere meno evidenti gli eventi di irrigazione o pioggia.",
  moisture_formula_old_description:
    "Più influenzata dalle fluttuazioni di temperatura, ma può mostrare più chiaramente gli eventi di irrigazione e pioggia.",
  moisture_formula_improvements:
    "Abbiamo significativamente migliorato e automatizzato la configurazione della calibrazione della temperatura. In precedenza, veniva compensato solo il pioppo nero. Ora cerchiamo di compensare il maggior numero possibile di specie arboree. Se ciò non è possibile, utilizziamo la specie arborea filogeneticamente più vicina.",
  moisture_formula_threshold_warning:
    "Con la nuova formula cambiano anche le soglie. Dopo il passaggio devono essere controllate e adeguate affinché avvisi e valutazioni rimangano corretti.",
  moisture_formula_learn_more: "Scopri di più",
  moisture_formula_wiki_link:
    "https://www.treesense.net/wiki_post/treesense-pulse-was-ist-der-treesense-feuchtigkeitsindex/",
  moisture_formula_note:
    "Nota: La scelta della formula influisce sulla visualizzazione dei valori di umidità in tutti i grafici.",
  moisture_content_display_setting: "Visualizzazione contenuto di umidità",
  moisture_content_display_description:
    "Scegli come TreeSense mostra i valori del contenuto di umidità.",
  moisture_content_display_fraction: "Frazione (0-1)",
  moisture_content_display_fraction_description: "Mostra valori come 0,34.",
  moisture_content_display_percent: "Percentuale (0-100)",
  moisture_content_display_percent_description: "Mostra valori come 34%.",
  moisture_content_cap_setting: "Limita valori contenuto di umidità",
  moisture_content_cap_description:
    "Limita valori a 0-1 / 0-100%. Disattiva per mostrare i valori analitici grezzi.",
  table_column_preferences: "Colonne visibili",
  table_column_preferences_hint:
    "Scegli quali colonne mostrare nelle tabelle di alberi, sensori e attività.",
  mobile_table_column_preferences: "Colonne mobili",
  mobile_table_column_preferences_hint:
    "Scegli quali 2 colonne mostrare sui dispositivi mobili (smartphone).",
  mobile_column: "Colonna",
  table_columns_trees: "Alberi",
  table_columns_sensors: "Sensori",
  table_columns_taska: "Compiti",
  reset_table_column_preferences: "Ripristina predefiniti",
  move_up: "Sposta su",
  move_down: "Sposta giù",
  settings_saved_successfully: "Impostazioni salvate con successo",
  action: "Azione",
  back: "Indietro",
  download_successful: "Download completato",
  evaluation: "Valutazione",
  filter: "Filtro",
  from: "Da",
  inactive: "Inattivo",
  last_date: "Ultima data",
  more_information: "Maggiori informazioni",
  no_data: "Nessun dato disponibile",
  no_data_found: "Nessun dato trovato",
  no_sensors_found: "Nessun sensore trovato",
  position: "Posizione",
  refresh_health: "Aggiorna dati di salute",
  refresh_health_error: "Aggiornamento dei dati di salute non riuscito",
  required: "Obbligatorio",
  select_sensor_search: "Cerca sensore...",
  something_wrong: "Qualcosa è andato storto",
  start_typing_to_search: "Inizia a digitare per cercare...",
  to: "A",

  // NB-IoT sensor configuration
  weekly_signal_avg: "Intensità del segnale (media 7g)",
  signal_strength: "Segnale",
  signal_low: "Basso",
  signal_medium: "Medio",
  signal_high: "Alto",
  signal_strength_info:
    "L'intensità del segnale influisce sulla durata della batteria. Un segnale basso consuma più batteria, un segnale medio consuma più di uno alto, e un segnale alto è il più efficiente.",
  signal_no_data: "Nessun dato",
  send_interval: "Intervallo di invio",
  measurement_interval: "Intervallo di misurazione",
  send_configuration: "Invia configurazione",
  downlink_queued: "Configurazione in coda per il prossimo uplink",
  downlink_failed: "Impossibile mettere in coda la configurazione",
  confirm_send_downlink: "Sei sicuro di voler inviare la configurazione al sensore?",
  no_intervals_configured: "Nessun intervallo configurato",
  interval_5min: "5 minuti",
  interval_10min: "10 minuti",
  interval_15min: "15 minuti",
  interval_30min: "30 minuti",
  interval_1h: "1 ora",
  interval_2h: "2 ore",
  interval_4h: "4 ore",
  interval_6h: "6 ore",
  interval_12h: "12 ore",
  interval_24h: "24 ore",

  // Irrigation Export
  irrigation_export_title: "Esporta piano di irrigazione",
  irrigation_export_button: "Esporta",
  yes: "Sì",
};
